function formatDate(dateString: string) {
  // Empty or unparseable input (e.g. 'Invalid date') yields '' so callers can skip the query
  if (!dateString || !/^\d{4}-\d{2}-\d{2}/.test(dateString)) return ''

  // Split the date part from the time part
  const [datePart] = dateString.split('T')

  // Extract year, month, and day
  const [year, month, day] = datePart.split('-')

  // Return the formatted string in MM-DD-YYYY format
  return `${month}-${day}-${year}`
}

export default formatDate
